import {NgModule} from '@angular/core';
import {WaitlistComponent} from './waitlist.component';
import {WaitlistRoutingModule} from './waitlist-routing.module';
import {ReactiveFormsModule} from '@angular/forms';
import {ChipsModule} from 'primeng/chips';
import {ButtonModule} from 'primeng/button';
import {E2xService} from '../../services';
import {AutoCompleteModule} from 'primeng/autocomplete';
import { SuccessScreenWaitListComponent } from './success-screen-wait-list/success-screen-wait-list.component';
import {DialogModule} from 'primeng/dialog';
import {CommonModule} from '@angular/common';
import {ProgressSpinnerModule} from 'primeng/primeng';

@NgModule({
  imports: [WaitlistRoutingModule, ReactiveFormsModule, ChipsModule, ButtonModule, AutoCompleteModule, DialogModule, CommonModule, ProgressSpinnerModule],
  declarations: [WaitlistComponent, SuccessScreenWaitListComponent],
  providers: [E2xService]
})
export class WaitlistModule {
}
